import React from 'react'
import { node, string } from 'prop-types'
import classNames from 'classnames'

import Type from '../../Type'
import SmartLink from '../../SmartLink'
import Icon from '../../Icon'

import styles from '../RelatedEntities.module.scss'

const Entity = ({ children, to, as }) => {
  const isLink = to && as
  const El = isLink ? SmartLink : 'div'
  return (
    <El
      className={classNames(styles.Entity, !isLink && styles.NoLink)}
      to={to}
      as={as}
    >
      <Type
        size={['heading7', 'heading5']}
        weight="bold"
        className={styles.Name}
      >
        {children}
      </Type>
      {isLink && (
        <Icon vAlign="middle" className={styles.Icon} type="arrow-right" />
      )}
    </El>
  )
}

Entity.propTypes = {
  children: node,
  to: string,
  as: string
}

export default Entity
